export default __webpack_public_path__ + "static/media/Kaguya_Normal_A.e81e0a0e.wav";